import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './SectionCombo.scss';

function SectionCombo() {
  const [activeIndex, setActiveIndex] = useState(null);

  const handlePedidoClick = () => {
    const url = 'https://pizzaprime.voceqpad.com.br/store/combo-exclusivo';
    window.open(url, '_blank'); // Abre a URL em uma nova aba
  };

  // Lista de combos
  const combos = [
    {
      title: 'Combo Exclusivo',
      items: ['1 Primezzita', '1 Refrigerante Lata'],
      price: '54,90',
      image: 'img/combos/Combo_Exclusivo.webp',
      url: 'https://pizzaprime.voceqpad.com.br/store/combo-exclusivo'
    },
    {
      title: 'Combo Premium',
      items: ['1 Pizza Grande', '1 Refrigerante 1,5L'],
      price: '83,90',
      image: 'img/combos/combo_premium.webp',
      url: 'https://pizzaprime.voceqpad.com.br/store/combo-premium-grande'
    },
    {
      title: 'Combo Supremo',
      items: ['1 Pizza Grande', '1 Pizza Peq. Doce', '1 Refrigerante 1,5L'],
      price: '118,90',
      image: 'img/combos/Combo_Supremo.webp',
      url: 'https://pizzaprime.voceqpad.com.br/store/combo-supremo-grande'
    },
    {
      title: 'Combo Extra',
      items: ['2 Pizzas Grandes', '1 Refrigerante 1,5L'],
      price: '148,90',
      image: 'img/combos/Combo_Extra.webp',
      url: 'https://pizzaprime.voceqpad.com.br/store/combo-extra-grande'
    }
  ];

  // Ref para observar os cartões de combo
  const cardRefs = useRef([]);

  useEffect(() => {
    const observerOptions = {
      root: null, // viewport
      rootMargin: '0px',
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in-combo');
        }
      });
    }, observerOptions);

    // Anexa o observador a cada cartão
    cardRefs.current.forEach(card => {
      if (card) {
        observer.observe(card);
      }
    });

    // Limpeza ao desmontar
    return () => {
      cardRefs.current.forEach(card => {
        if (card) {
          observer.unobserve(card);
        }
      });
    };
  }, []);
  return (
    <>
      <div className='topoCombos'>
        <h1>Combos Pizza Prime</h1>
        <h2>Aproveite Nossas Ofertas de Pizzas</h2>
        <p>
          Descubra os combos especiais da Pizza Prime e aproveite as melhores ofertas de pizzas e acompanhamentos.
        </p>
      </div>
      <div className="combos-grid" id='combosSection'>
        {combos.map((combo, index) => (
          <div 
            className={`combo-card ${activeIndex === index ? 'combo-ativado' : ''}`} 
            key={index} 
            ref={el => (cardRefs.current[index] = el)}
            onMouseEnter={() => setActiveIndex(index)}
            onMouseLeave={() => setActiveIndex(null)}
          >
            <div 
              className={`card-backEffect ${activeIndex === index ? 'combo-ativado' : ''}`} 
            ></div>
            <div className={`combo-details ${activeIndex === index ? 'combo-ativado' : ''}`} >
              <div className='combo-description'>
                <div className={`combo-title ${activeIndex === index ? 'combo-ativado' : ''}`} >
                  {combo.title}
                </div>
                <div className={`combo-itens ${activeIndex === index ? 'combo-ativado' : ''}`} >
                  {combo.items.map((item, idx) => (
                    <div key={idx}>{item}</div>
                  ))}
                </div>
              </div>
              <div className='combo-price'>
                <div className='combo-price-box'>
                  <div className='rs'>R$</div>
                  <div className={`price-whole ${activeIndex === index ? 'combo-ativado' : ''}`} >
                    {combo.price.split(',')[0]}
                  </div>
                  <div className='price-decimal'>,{combo.price.split(',')[1]}</div>  
                </div>
              </div>
            </div>  
            <div className={`combo-image ${activeIndex === index ? 'combo-ativado' : ''}`} >
              <img src={combo.image} alt={combo.title} />
            </div>  
            
            <div className={`combo-bt-pedir ${activeIndex === index ? 'combo-ativado' : ''}`} >
              <a 
                href={combo.url} 
                target="_blank" 
                rel="noopener noreferrer" 
                className={`a-btpedir ${activeIndex === index ? 'combo-ativado' : ''}`} 
              >
                Ver Combo
              </a>
            </div>
          </div>
        ))}
      </div>

    </>
  );
}

export default SectionCombo;
